import { FormPageContainer } from '@strata/react-form-header-and-content';
import { WorklistWithFilters } from '@strata/react-worklist';

import { usePermissionCheck, useWorklistTasks } from 'services/APIHooks';
import { Permissions } from 'services/constants';
import { useOnTaskActionClick, useOnUnableToComplete } from 'services/worklistHelpers';
import { useAppDispatch } from 'store';
import { usePostClearWorklistTasksMutation } from 'store/api/worklistApi';
import { useLoggedInSupplierName } from 'store/auth/authThunks';
import { Grids } from 'store/grids/gridsSlice';
import { useGridState } from 'store/grids/gridThunks';
import { fetchWorklistTasks } from 'store/worklist/worklistThunks';

export const WorklistPage = () => {
    const dispatch = useAppDispatch();
    const loggedInSupplierName = useLoggedInSupplierName();
    const worklistTasks = useWorklistTasks();

    const writeWorklist = usePermissionCheck(Permissions.WRITE_WORKLIST);

    const onTaskActionClick = useOnTaskActionClick(true);
    const onUnableToComplete = useOnUnableToComplete();

    const [postClearWorklistTasks] = usePostClearWorklistTasksMutation();
    const onClearTasksClick = (taskIds: string[]) => {
        (async () => {
            await postClearWorklistTasks({ taskIds }).unwrap();
            await dispatch(fetchWorklistTasks());
        })();
    };

    const {
        search,
        activeFilters,
        filterPaneWidth,
        updateGridSearch,
        updateGridActiveFilters,
        updateFilterPaneWidth,
    } = useGridState(Grids.WORKLIST);

    return (
        <FormPageContainer>
            <WorklistWithFilters
                title="Worklist"
                secondaryTitle={loggedInSupplierName}
                tasks={worklistTasks}
                onClearTasksClick={writeWorklist ? onClearTasksClick : undefined}
                onUnableToComplete={writeWorklist ? onUnableToComplete : undefined}
                onTaskActionClick={onTaskActionClick}
                activeFilters={activeFilters}
                onFilter={updateGridActiveFilters}
                filterPaneRenderWidth={filterPaneWidth}
                onFilterPaneResize={updateFilterPaneWidth}
                searchText={search}
                onSearch={updateGridSearch}
            />
        </FormPageContainer>
    );
};
